import React from "react";
import { Row, Col } from "react-bootstrap";
import { AdminUser } from "@preveil-api";
import _ from "lodash";

type AllProps = {
  users: AdminUser[];
}

// Description: Component to display the user information in the admin panel. - used in the resend invites modal and the add users modal.
function UserInfoCardComponent(props: AllProps) {
  const { users } = props;

  return <div className="table-display">
    <Row className="header-card-row">
      <Col xs={7}>Name</Col>
      <Col xs={5}>Department</Col>
    </Row>
    <div className="table-body">
      {_.map(users, (user: AdminUser, index: number) => {
        return (
          <Row key={index}>
            <Col xs={7}>
              <p className="semi-bold">{user.display_name}</p>
              <p>{user.user_id.toLowerCase()}</p>
            </Col>
            <Col xs={4}>{user.department}</Col>
          </Row>
        );
      })}
    </div>
  </div>;
}


export default React.memo(UserInfoCardComponent);
